import type { FeedFilters } from '@/features/markets/components/Feed/api/fetchFeedData';

export const feedKeys = {
  all: ['feed'] as const,
  data: (metadata: FeedFilters) => [...feedKeys.all, metadata] as const
};
